import { useQuery } from "@tanstack/react-query";
import { http } from "../../shared/api/http.js";
import type { ThemeId } from "@smartvow/shared";

export interface WallItem {
  id: string;
  kind: "image" | "video";
  pseudo: string;
  note: string | null;
  image: string;
  video: string | null;
}

export interface Wall {
  event: { name: string; date: string; location: string | null; theme: ThemeId };
  wedding: { partner1Name: string; partner2Name: string; story: string | null };
  wallMessage: string | null;
  guestUrl: string;
  qrDataUrl: string;
  couplePhotoUrls: string[];
  items: WallItem[];
}

export const useWall = (slug: string, token: string | undefined) =>
  useQuery({
    queryKey: ["wall", slug, token],
    enabled: !!token,
    refetchInterval: 15_000,
    queryFn: () => http.get<Wall>(`/wall/${slug}?t=${encodeURIComponent(token!)}`),
  });
